import { push } from "connected-react-router";
import { useCallback, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION, ROUTE_PATH } from "../../app/constants";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils'
import { Header, Button } from "../../components/RegularComponents";
import { lenderNextStepSelect } from "../../redux/selector/lenderNextStepSelector";
import { fetchApplicationWithIdAndSetStore } from "../../redux/slice/collectionApplicationSlice";
import { IsInternalId } from "../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../TopNavigationBar";

const LenderNextSteps = (props) => {
  const dispatch = useDispatch();

  const { lenderNextStep } = props;
  const {
    applicationId,
    businessLicenceData,
    companyRjscDetails,
    agencyApplicationReview,
  } = lenderNextStep;

  const { licencingSubType } = useSelector((state) => ({
    licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  }));

  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const isLender = applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE;

//   const {
//     mainBusinessContact = {},
//     financialRecordsLocation = {},
//     companyFiscalEndDate = 0,
//     serviceBusinessAddress = {},
//     responsibleAgent = {}
//   } = businessLicenceData;

//   const { lenderApplication } = useSelector(lenderBrokerSelector);
//   const lenderApplicationState =
//     lenderApplication?.businessLicenceData ?? {};

//   const { personData, confirmCompletionRegulatoryInfo } = lenderApplicationState;

  const style = {
    successStep: {
      backgroundColor: "white",
      borderStyle: "solid",
      borderWidth: "1px",
      color: "green",
      left: "-45px",
    },
    toDoStep: {
      backgroundColor: "white",
      borderStyle: "solid",
      borderWidth: "1px",
      color: "gray",
      left: "-45px",
    },
    rowSpacer: {
      marginTop: "20px",
    },
    contentSpacer: {
      marginLeft: "25px",
    },
  };

  const isRjscStepDone = useCallback(() => {
    if (
      companyRjscDetails &&
      companyRjscDetails.businessEntity &&
      companyRjscDetails.businessEntity.registryNumber
    ) {
      return true;
    }

    return false;
  }, [companyRjscDetails]);

  const isLenderStepDone = useCallback(() => {
    if (agencyApplicationReview > 0) {
      return true;
    }
    return false;
  }, [agencyApplicationReview]);

  const isPayStepDone = useCallback(() => {
    // console.log(
    //   "What is the data?",
    //   mainBusinessContact,
    //   financialRecordsLocation,
    //   appointedAgentServiceAddress,
    //   companyFiscalEndDate,
    //   uploadCriminalRecordCheck,
    //   uploadedProofOfInsurance,
    //   principalBrokerDutiesConfirmation,
    //   agencyApplicationReview
    // );

    // TODO : add documents check for completion.
    if (false) {
      return true;
    }
    return false;
  }, []);

  const isLenderApproveStepDone = () => {
    return false;
  };

  const stepDone = (step) => {
    switch (step) {
      case 1:
        return isRjscStepDone();
      case 2:
        return isLenderStepDone();
      case 3:
        return isPayStepDone();
      case 4:
        return isLenderApproveStepDone();
      case 5:
        return (
          isRjscStepDone() &&
          isLenderStepDone() &&
          isPayStepDone() &&
          isLenderApproveStepDone()
        );
      default:
        return false;
    }
  };

  const isStepCurrent = (step) => {
    switch (step) {
      case 1:
        return (
          !isRjscStepDone() &&
          !isLenderStepDone() &&
          !isPayStepDone() &&
          !isLenderApproveStepDone()
        );
      case 2:
        return (
          isRjscStepDone() &&
          !isLenderStepDone() &&
          !isPayStepDone() &&
          !isLenderApproveStepDone()
        );
      case 3:
        return (
          isRjscStepDone() &&
          isLenderStepDone() &&
          !isPayStepDone() &&
          !isLenderApproveStepDone()
        );
      case 4:
        return (
          isRjscStepDone() &&
          isLenderStepDone() &&
          isPayStepDone() &&
          !isLenderApproveStepDone()
        );
      default:
        return false;
    }
  };

  useEffect(() => {
    if (!businessLicenceData 
        && applicationId 
        && !IsInternalId(applicationId)) {
      dispatch(fetchApplicationWithIdAndSetStore(applicationId));
    }
  }, [
    applicationId, 
    businessLicenceData, 
    dispatch
  ]);

  const nextRoutePath = useCallback(() => {
    return isLender ? ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP
  }, [isLender])

  return (
    <>
      <div className={"container"}>
      <TopNavigationBar 
              {...props} 
              applicationType={applicationType} 
              applicationMode={APPLICATION_MODE_NEW} />
        <div className="row">
          <div className="col-xs-12 col-lg-11">
            <Header
              id="broker-next-steps-header"
              header={ isLender ? 
                "Steps to complete your Mortgage Lender Licence application" : 
                "Steps to complete your Mortgage Administrator Licence application"
              }
            />
          </div>
        </div>

        <div style={style.contentSpacer} className="timeline row">
          <ol>
            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(1) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(1) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 1</span>
                  {stepDone(1) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(1) ? (
                    <>&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Provide your company information
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                    {`If your company is registered with the Nova Scotia Registry of Joint Stock Companies (RJSC), 
                    you can enter your company name or RJSC number to review your company information 
                    that was already provided. A small number of companies are not registered with RJSC. 
                    These companies will need to enter their company information manually.`}
                    </span>
                  </div>
                </div>
                {(isStepCurrent(1) || stepDone(1)) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={stepDone(1) ? "Review your answers" : "Start now"}
                        onClick={() => {
                          if(stepDone(1)) {
                            // mra/mra-review-business-info
                            dispatch(
                              push(
                                `${nextRoutePath()}${ROUTE_PATH.ML_RJSC_DETAIL_REVIEW}`
                              )
                            );
                          } else { 
                            dispatch(
                              push(
                                `${nextRoutePath()}${ROUTE_PATH.ML_RJSC_SEARCH}`
                              )
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>

            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(2) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(2) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 2</span>
                  {stepDone(2) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(2) ? (
                    <>&nbsp;&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                     {( isLender ? 
                          "Complete an application for a Mortgage Lender Licence" :  
                          "Complete an application for a Mortgage Administrator Licence"
                      )}
                    </span>
                  </div>
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      Provide information about your company and provide criminal record check documents for your
                      compliance officer, partners, and officers at your company.  If you're a sole proprietor,
                      you'll provide your own criminal record check.
                    </span>
                  </div>
                </div>
                {(isStepCurrent(2) || stepDone(2)) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={stepDone(2) ? "Review your answers" : "Start now"}
                        onClick={() => {
                          dispatch(
                            push(
                              `${nextRoutePath()}${ROUTE_PATH.ML_SELECT_LENDER}`
                            )
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>

            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(3) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(3) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 3</span>
                  {stepDone(3) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(3) ? (
                    <>&nbsp;&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Pay for your application
                    </span>
                  </div>
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      You can pay for your application by credit card (VISA, Mastercard, American Express) or credit/debit
                      cards (a debit card with the Visa or Mastercard logo).
                    </span>
                  </div>
                </div>
                {(isStepCurrent(3) || stepDone(3)) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={stepDone(3) ? "Review your answers" : "Start now"}
                        onClick={() => {
                          // On to the next item
                          dispatch(
                            push(
                              `${nextRoutePath()}${ROUTE_PATH.ML_PAYMENT_PREVIEW}`
                            )
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>

            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(4) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(4) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 4</span>
                  {stepDone(4) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(4) ? (
                    <>&nbsp;&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Your application is submitted and will be reviewed
                    </span>
                  </div>
                </div>
                <div style={style.rowSpacer} className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      
                    </span>
                  </div>
                </div>
                <div style={style.rowSpacer} className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      To see your licence status, go to the home page of Nova
                      Scotia Mortgage Licensing Service. When your licence is
                      reviewed, you'll receive a notification by email from the
                      Business Licensing team and Service Nova Scotia and
                      Internal Services.
                    </span>
                  </div>
                </div>
                {isStepCurrent(4) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={"Start now"}
                        onClick={() => {
                          // On to the next item
                          dispatch(
                            push(
                              `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_ADD_BROKERS_TO_BROKERAGE}`
                            )
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

// export default connect(mraBrokerNextStepSelect)(LenderNextSteps);
export default connect(lenderNextStepSelect)(LenderNextSteps);